<script setup lang="ts">
import { SelectValue, type SelectValueProps } from 'radix-vue';

const props = defineProps<SelectValueProps & { testId?: string}>();
</script>

<template>
  <SelectValue v-bind="props" class="text-[0.938rem] truncate" :data-testid="props.testId">
    <slot />
  </SelectValue>
</template>
